import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { IProfileRecord, ISegment } from "../../../../Models/Models";
import { SegImg, getPrettyNumber } from "../../../Common/";
import {
    lightBorderGray,
    colorTwoBright,
} from "../../../../globalStyles/colors/scoutColors";
import { BsQuestionCircle } from "@react-icons/all-files/bs/BsQuestionCircle";

interface IPsychProfSummProps {
  segDets: ISegment[];
  topSegs: IProfileRecord[];
}

const PsychProfSummWrap = styled.div`
  width: 100%;
  /* display: grid;
  grid-template-columns: 100px 209px 174px 129px 145px 114px;
  place-items: stretch;
  align-items: center;
  font-size: 11px;
  > div {
    border-bottom: 1px solid;
  } */
`;

const PPSummRow = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px;
  font-size: 11px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${lightBorderGray};
  padding-bottom: 7px;
  margin-bottom: 10px;
  line-height: normal;
  &:first-child {
  }
`;

const HuWeR = styled.h3`
  font-size: 20px;
  font-weight: bold;
  padding: 3px 5px;
  white-space: nowrap;
  color: ${colorTwoBright};
  margin: 0;
`;

const OthH = styled.h4`
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  margin: 0;
`;

const MiniH = styled.h5`
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  margin: 0 0 2px 0;
`;

const ImgWrap = styled.div`
  width: 100px;
  text-align: center;
`;

const NameDetWrap = styled.div`
  width: 209px;
`;

const VarNmWrap = styled.div`
  width: 174px;
  text-align: right;
  font-weight: 600;
`;

const VarValWrap = styled.div`
  width: 129px;
  padding-left: 29px;
`;

const SweetStatsBruh = styled.div`
  text-align: center;
  width: 90px;
`;

export const PsychProfSumm: FunctionComponent<IPsychProfSummProps> = (
    props: IPsychProfSummProps
) => {
    const { topSegs, segDets } = props;

    return (
        <PsychProfSummWrap>
            <PPSummRow>
                <ImgWrap>
                    <HuWeR>Who We Are</HuWeR>
                </ImgWrap>
                <NameDetWrap></NameDetWrap>
                <VarNmWrap></VarNmWrap>
                <VarValWrap>
                    <OthH>Details</OthH>
                </VarValWrap>
                <SweetStatsBruh>
                    <OthH>Index Score</OthH>
                </SweetStatsBruh>
                <SweetStatsBruh>
                    <OthH>Segment %</OthH>
                </SweetStatsBruh>
            </PPSummRow>
            {topSegs.map((topSeg, i) => {
                const segDet = segDets.find((seg) => topSeg.seg === seg.segmentKey);
                return (
                    <PPSummRow key={`${topSeg.seg}-row-${i}`}>
                        <ImgWrap>
                            <SegImg
                                style={{ width: "80px", height: "80px" }}
                                src={`/Images/segmentation-imgs/${topSeg.seg}.jpg`}
                            />
                        </ImgWrap>
                        <NameDetWrap>
                            <MiniH>
                                {topSeg.seg} {segDet.name}
                            </MiniH>
                            <div>{segDet.description}</div>
                        </NameDetWrap>
                        <VarNmWrap>
                            {segDet.segmentDetails.map((det, k) => {
                                return (
                                    <div
                                        key={`segDet-varNM-${det.varNm
                                            .replace(/\s/g, "-")
                                            .toLowerCase()}-${i + k}`}
                                    >
                                        {det.varNm}:
                                    </div>
                                );
                            })}
                        </VarNmWrap>
                        <VarValWrap>
                            {segDet.segmentDetails.map((det, k) => {
                                return (
                                    <div
                                        key={`segDet-varVal-${det.category
                                            .replace(/\s/g, "-")
                                            .toLowerCase()}-${i + k}`}
                                    >
                                        {det.varVal}
                                    </div>
                                );
                            })}
                        </VarValWrap>
                        <SweetStatsBruh>
                            {segDet.segmentDetails.map((det, k) => {
                                return (
                                    <div
                                        key={`segDet-idx-${det.category
                                            .replace(/\s/g, "-")
                                            .toLowerCase()}-${i + k}`}
                                    >
                                        {det.idx}
                                    </div>
                                );
                            })}
                        </SweetStatsBruh>
                        <SweetStatsBruh>
                            {segDet.segmentDetails.map((det, k) => {
                                return (
                                    <div
                                        key={`segDet-pct-${det.category
                                            .replace(/\s/g, "-")
                                            .toLowerCase()}-${i + k}`}
                                    >
                                        {getPrettyNumber(det.pct, 1)}%
                                    </div>
                                );
                            })}
                        </SweetStatsBruh>
                    </PPSummRow>
                );
            })}
            <div style={{ display: "flex", alignItems: "center" }}>
                <BsQuestionCircle
                    size={24}
                    style={{ marginRight: "8px", width: "42px" }}
                />
                <p style={{ fontSize: "11px", marginBottom: "0" }}>
          An index value of 100 represents the average value for the analysis
          group. The further above/below 100 the index is for a given location,
          the more extreme the observed value for that location. Segment %
          represents the percentage of all households in segment with this
          characteristic.
                </p>
            </div>
        </PsychProfSummWrap>
    );
};
